import { jsx as a, Fragment as w, jsxs as l } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import $ from "./logo.webp.js";
import v from "./menu-dropdown-wrapper-mobile.svg.js";
import O from "./burger.svg.js";
import y from "./close.svg.js";
import { useState as C, useCallback as h, useMemo as A } from "react";
import { AccountLink as G } from "./account-link/index.js";
import k from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as x } from "./dropdown-menu-item/index.js";
import { useDisableScroll as S } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as H } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as R } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as T } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as I } from "./get-help-menu-item/index.js";
import { GradientButton as q } from "./gradient-button/index.js";
import { MenuChatButtonMobile as B } from "./chat-button/index.js";
import j from "./chevron-right-gradient.svg.js";
const le = (t) => {
  const {
    isAuthenticated: r,
    openAuthModal: n,
    getTranslation: i,
    language: f,
    lmpEnabled: o,
    onRequestLawyer: g
  } = t, [c, u] = C(!1);
  S({ isDisabled: c });
  const m = h(() => {
    u(!0);
  }, []), s = h(() => {
    u(!1);
  }, []), d = h(() => {
    u(!1), r || n();
  }, [r, n]), p = h(() => {
    u(!1), t.logout();
  }, [t.logout]);
  return /* @__PURE__ */ a(w, { children: /* @__PURE__ */ l(
    "div",
    {
      className: `${e.menuModalOverlay} ${c ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          E,
          {
            isMenuOpen: c,
            closeMenu: s,
            openMenu: m,
            onAccountClick: d,
            handleLogout: p,
            isAuthenticated: t.isAuthenticated,
            userImage: t.userImage,
            hasNotifications: t.hasNotifications,
            language: f,
            getTranslation: i,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: g
          }
        ),
        /* @__PURE__ */ a(
          F,
          {
            isAuthenticated: t.isAuthenticated,
            language: f,
            handleLogout: p,
            closeMenu: s,
            hasNotifications: t.hasNotifications,
            userImage: t.userImage,
            onAccountClick: d,
            getTranslation: i,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: g,
            lmpEnabled: o
          }
        ),
        /* @__PURE__ */ a(v, { className: e.mobileBGIcon })
      ]
    }
  ) });
}, E = (t) => {
  const {
    isMenuOpen: r,
    closeMenu: n,
    openMenu: i,
    onAccountClick: f,
    handleLogout: o,
    isAuthenticated: g,
    hasNotifications: c,
    userImage: u,
    language: m,
    getTranslation: s,
    isLawyerSupported: d,
    onRequestLawyer: p
  } = t, [M, L] = C(!1), N = h(() => {
    L(!0);
  }, []), b = h(() => {
    L(!1);
  }, []);
  return /* @__PURE__ */ l("div", { className: e.mobileMenuContainer, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: r ? n : i,
        children: /* @__PURE__ */ l("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: O,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${r ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: y,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${r ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: m ? `/${m}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: $,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    g ? /* @__PURE__ */ a(
      G,
      {
        isAuthenticated: g,
        userImage: u,
        openAuthModal: f,
        logout: o,
        hasNotifications: c,
        closeMenuModal: n,
        language: m,
        getTranslation: s
      }
    ) : d ? /* @__PURE__ */ l(w, { children: [
      /* @__PURE__ */ a(
        q,
        {
          label: s("pages.get-help"),
          onClick: N,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ a(
        I,
        {
          language: m || "en",
          titleLabel: s("pages.get-help"),
          getTranslation: s,
          isLawyerSupported: d,
          onRequestLawyer: p,
          closeMenu: b,
          externalIsOpen: M,
          externalOnOpen: N,
          externalOnClose: b,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ a(B, { getTranslation: s })
  ] });
}, F = (t) => {
  const {
    handleLogout: r,
    language: n,
    closeMenu: i,
    onAccountClick: f,
    getTranslation: o,
    isLawyerSupported: g,
    lmpEnabled: c,
    onRequestLawyer: u
  } = t, [m, s] = C(!1), d = h(() => {
    s(!0);
  }, []), p = h(() => {
    s(!1);
  }, []), M = A(() => {
    var N;
    const L = (N = H[n]) == null ? void 0 : N.map((b) => ({
      ...b,
      path: `/${n}/topics/${D(b.title)}`
    }));
    return L || null;
  }, [n]);
  return /* @__PURE__ */ l("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ l("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: d,
          children: [
            /* @__PURE__ */ a("div", { className: e.gradientTextContent, children: o("pages.get-help") }),
            /* @__PURE__ */ a(j, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ a(
        I,
        {
          language: n,
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: g,
          onRequestLawyer: u,
          closeMenu: p,
          externalIsOpen: m,
          externalOnOpen: d,
          externalOnClose: p,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      c ? /* @__PURE__ */ l("a", { href: n ? `/${n}/find` : "/find", className: e.mainMenuLink, onClick: i, children: [
        "Browse lawyers",
        /* @__PURE__ */ a(k, { className: e.arrowIcon })
      ] }) : null,
      M && /* @__PURE__ */ a(
        x,
        {
          language: n,
          titleLabel: o("pages.legal-topics"),
          link: `/${n}/topics`,
          items: M,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      c ? null : /* @__PURE__ */ a(
        "a",
        {
          href: `/${n}/about/company`,
          className: e.mainMenuLink,
          onClick: i,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ a(
        T,
        {
          language: n,
          getTranslation: o,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      t.isAuthenticated ? /* @__PURE__ */ a(
        R,
        {
          language: n,
          handleLogout: r,
          userImage: t.userImage,
          hasNotifications: t.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ l("div", { className: e.mainMenuLink, onClick: f, children: [
        o("pages.account"),
        /* @__PURE__ */ a(k, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: i,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: i,
          children: o("pages.faqs")
        }
      ),
      M && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: i,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: i,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  le as MobileMenu
};
